import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ScrollToTop from 'components/ScrollToTop';
import Home from './Dashboard';
import AuthRoute from './Auth/AuthRoute';
import AppLayout from './layouts/AppLayoutContainer';
import SplashScreen from 'components/SplashScreenContainer';
import ListGames from './ListGames';
const Routes = () => (
  <ScrollToTop>
    <Switch>
      <Route path="/" exact component={SplashScreen} />
      <Route path="/home" exact component={Home} />
      <Route path="/listgames" exact component={ListGames} />
      <AppLayout>
        <Route path="/auth" component={AuthRoute} />
      </AppLayout>
    </Switch>
  </ScrollToTop>
);

export default Routes;
